export enum KioskTypeEnum {
    SINGLE_SIDE = "Single Side",
    DOUBLE_SIDE = "Double Side",
    // CUBICLE = "Cubicle"
}